module.exports = __webpack_public_path__ + "img/GiftImage.84b33144.jpg";